import { useCurrentUser } from '@/user/use-current-user.query';
import { useAccount } from './queries/use-account.query';

export const useCurrentAccountData = () => {
  const { data: user } = useCurrentUser();

  return useAccount(user?.account.id);
};
